// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Collator/Collator
const stringComparer = new Intl.Collator(undefined, {
    usage: 'sort',
    sensitivity: 'base',
    ignorePunctuation: true,
    numeric: true,
});

//
// Shared function that performs sorting of names that also
// handles the correct sorting of numbers within the name
// (such as building addresses, firmware versions, etc.)
//
export function sortNames(aName: string, bName: string): number {
    return stringComparer.compare(aName, bName);
}

export function sortNamesBy<T>(nameAccessor: (t: T) => string) {
    return (a: T, b: T): number => {
        const aName = nameAccessor(a);
        const bName = nameAccessor(b);
        return stringComparer.compare(aName, bName);
    };
}

export function sortFloorLabels(aLabel: string, bLabel: string) {
    // Convert labels to numbers if possible
    const numA = parseFloat(aLabel);
    const numB = parseFloat(bLabel);

    if (!isNaN(numA) && !isNaN(numB)) {
        return numA - numB;
    }
    if (!isNaN(numA)) {
        return -1;
    }
    if (!isNaN(numB)) {
        return 1;
    }

    // Neither label is numeric, fall back to string comparison
    return stringComparer.compare(aLabel, bLabel);
}